import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { useCookie } from "../../../hooks/useCookie";
import { useToast } from "../../../hooks/useToast";
import { general } from "../../../locales/general";
import apiService from "../../../service/apiService";
import { TranslationRow, TranslationTable } from "../Translationtableparts";

function TableBodyRowContent({
  serviceCategoryTranslation,
  deletedList,
}: {
  serviceCategoryTranslation: ServiceCategoryTranslation;
  deletedList: React.Dispatch<BulkDeleteActions>;
}) {
  const { toastSuccess, toastError } = useToast();
  const { token } = useCookie("vToken");
  const queryClient = useQueryClient();

  const deleteServiceCategoryTranslation = useMutation((id: string) => {
    return apiService.MakeDeleteRequest(
      `service-category-translations/${id}`,
      token,
    );
  });

  const removeServiceCategoryTranslation = () => {
    deleteServiceCategoryTranslation.mutate(serviceCategoryTranslation.id, {
      onError(error) {
        console.log(error);
        toastError(general.fr.message.operationFailed);
      },
      onSuccess() {
        toastSuccess(general.fr.message.partnerDeleted);
        queryClient.invalidateQueries("getAllTranslations");
      },
    });
  };

  return (
    <TranslationRow
      id={serviceCategoryTranslation.id}
      deletedList={deletedList}
      sourceTitle={serviceCategoryTranslation.serviceCategory?.label}
      translation={serviceCategoryTranslation?.label}
      lang={serviceCategoryTranslation?.lang}
      editTo={`/service-category-translations/update/${serviceCategoryTranslation.id}`}
      onDelete={removeServiceCategoryTranslation}
      isDeleting={deleteServiceCategoryTranslation.isLoading}
    />
  );
}

interface TableProps {
  serviceCategoryTranslations: ServiceCategoryTranslation[];
  serviceCategoryTranslationsToBeDeleted: React.Dispatch<BulkDeleteActions>;
}

export default function ServiceCategoryTranslationsTable({
  serviceCategoryTranslations,
  serviceCategoryTranslationsToBeDeleted,
}: TableProps) {
  return (
    <TranslationTable sourceLabel="Catégorie">
      {serviceCategoryTranslations?.map((serviceCategoryTranslation) => (
        <TableBodyRowContent
          serviceCategoryTranslation={serviceCategoryTranslation}
          key={serviceCategoryTranslation?.id}
          deletedList={serviceCategoryTranslationsToBeDeleted}
        />
      ))}
    </TranslationTable>
  );
}
